if(!customElements.get('vbb-featured-set')) {
  customElements.define('vbb-featured-set', class FeaturedSet extends HTMLElement {
    constructor() {
      super();

      this.container = this.querySelector('.vbb-featured-set__container');
      this.isSet = this.dataset.isSet === 'true';
    }

    getSection() {
      fetch(this.dataset.productUrl)
        .then(response => response.text())
        .then(responseText => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.container.innerHTML = this.productElement.innerHTML;

          this.container.querySelectorAll('script').forEach(oldScriptTag => {
            const newScriptTag = document.createElement('script');
            Array.from(oldScriptTag.attributes).forEach(attribute => newScriptTag.setAttribute(attribute.name, attribute.value));
            newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
            oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
          });
        });
    }

    connectedCallback() {
      if (!this.isSet) {
        this.remove();
      }

      this.getSection();
    }
  });
}
